
import React from 'react';
import {  useNavigate, } from 'react-router-dom';
import { getUserData } from '../../utils/localStorage';

const { innerWidth: width, innerHeight: height } = window;

const RiderJobs = () => {
  const navigate = useNavigate(); 

  const { userProfileRole, brandProfileData, storeData } = getUserData();
  
    const userRole = userProfileRole;
    
  let enabledCustomerJeoLocationByAddress = brandProfileData.enabledCustomerJeoLocationByAddress;

  const lat = storeData?.address?.latitude;
  const lng = storeData?.address?.longitude;

  const handleBackButton = () => {
     
      navigate('/');
     
  }


  return (
    <div className="flex-1">
      <div className='h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center' style={{
        "--surface-0": "#1752AA"
      }}>
        <div className='flex-1 flex ml-3 mr-3'>
          <div className="flex-1 flex " >
            <div className="ml-3 flex justify-content-center align-items-center" >
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i className="pi pi-angle-left" onClick={() => handleBackButton()} style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}></i>
              </div>
            </div>
            <div className="flex-1 ml-5" >
              <p className=" text-2xl text-white font-bold capitalize">
              Rider Jobs</p>
            </div>
            {userRole === "BY_STORE" && lat && lng && enabledCustomerJeoLocationByAddress && <div
              className="mr-4 mt-2 cursor-pointer"
              onClick={() =>
                navigate("/pickup-delivery-map")
              }
            >
              <img
                src="/warehouse/place.png"
                alt="config"
                style={{
                  width: 27,
                }}
              />
            </div>}
          </div>

          {userRole === "BY_ADMIN" && <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => navigate("/PickupJobForm")}
          >
            <p className=" text-2xl text-white font-bold capitalize mr-3">Add New Pickup</p>
            <div className="flex justify-content-center align-items-center relative bg-white border-circle shadow-4 align-self-center">
              <img
                style={{
                  position: "relative",
                  top: "-5px",
                  width: height < 600 ? "30px" : "40px",
                }}
                src="/Laundy_App_Icons_Gifs/Customer_Info_GIFs/Pickup_Request.gif"
                alt="logo"
              />
            </div>
          </div>}

        </div>
      </div>

      <div className='flex-1 h-full'>
        <div className="flex-1 my-3 mt-5" >
          <div className='flex-1 flex flex-row justify-content-around align-items-center'
            onClick={
              () => navigate('/PickupJob')
            }
            style={{cursor:"pointer"}}
          >
            <div className='flex-1 flex align-self-center justify-content-center'>
              <img
                src={"VectorsLaundryApp/7.png"}
                style={{
                  alignSelf: 'center',
                  width:
                    height < 600 ? "12%" : '15%',
                }}
              />
            </div>
            <div className='flex flex-1 align-center flex-column'
            >
              <img
                src={"Laundy_App_Icons_Gifs/Customer_Info_GIFs/Pickup_Request.gif"}
                style={{
                  width: height < 600 ? "17%" : "20%",
                  height: height < 600 ? "17%" : "20%",
                  alignSelf: 'center',
                }}
              />

              <div className='mx-2 py-4'>
                <p className='text-5xl font-bold text-center ' style={{ color: "#2B70D7" }}>Pickup Job</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1" >
          <div
            className='flex-1 flex flex-row-reverse justify-content-around align-items-center'
            onClick={() => navigate('/DeliveryJob')}
            style={{cursor:"pointer"}}
          >
            <div className='flex-1 flex align-self-center justify-content-center'>
              <img
                src={"VectorsLaundryApp/8.png"}
                style={{
                  alignSelf: 'center',
                  width:
                    height < 600 ? "12%" : '15%',

                }}
              />
            </div>
            <div className='flex flex-1 align-center flex-column'>
              <img
                src={"Laundy_App_Icons_Gifs/Customer_Info_GIFs/Deliver_Request.gif"}
                style={{
                  width: height < 600 ? "24%" : "30%",
                  height: height < 600 ? "24%" : "30%",
                  alignSelf: 'center',
                }}
              />
              <div className='mx-2 py-4'>
                <p className='text-5xl font-bold text-center ' style={{ color: "#2B70D7" }}>Delivery Job</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default RiderJobs;

